import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { firstFlowsActions } from 'features/firstFlows';

const useFirstFlows = () => {
  const dispatch = useDispatch();
  const getFirstFlow = useCallback(() => dispatch(firstFlowsActions.getFirstFlow()), [dispatch]);
  const createFirstFlow = useCallback(first_flow => dispatch(firstFlowsActions.createFirstFlow(first_flow)), [dispatch]);
  const updateFirstFlow = useCallback(first_flow => dispatch(firstFlowsActions.updateFirstFlow(first_flow)), [dispatch]);
  const deleteFirstFlow = useCallback(() => dispatch(firstFlowsActions.deleteFirstFlow()), [dispatch]);
  const clearLocalActiveFirstFlow = useCallback(() => dispatch(firstFlowsActions.clearLocalActiveFirstFlow()), [dispatch]);

  return {
    getFirstFlow,
    createFirstFlow,
    updateFirstFlow,
    deleteFirstFlow,
    clearLocalActiveFirstFlow
  };
};

export default useFirstFlows;